import { HTTP_INTERCEPTORS, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import 'rxjs/add/operator/switchMap';
import { RequestUtils } from '../shared/utils/request';
import { IState } from '../shared/models/state';
import { getAuthTokenSelector } from '../shared/auth/auth.reducer';
import 'rxjs/add/operator/combineLatest';
import { getUserDetailsSelector } from '../shared/user/user.reducer';
import { accountFromLocalStorage } from '../../../old-crazy-web-frontend/src/app/utils/account-from-localstorage';

@Injectable()
export class AuthorizedHeader implements HttpInterceptor {
  constructor(private store: Store<IState>, private requestUtils: RequestUtils) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.headers.has('Authorization') && req.headers.has('account')) {
      return next.handle(req);
    } else {
      return this.store
        .select(getAuthTokenSelector)
        .withLatestFrom(this.store.select(getUserDetailsSelector))
        .take(1)
        .switchMap(([token, user]) => {
          if (token && this.requestUtils.isOurDomain(req)) {
            req = req.clone({
              setHeaders: {
                Authorization: `Bearer ${token}`
              }
            });

            // TODO: find a better solution
            //  The following code fixes the issue that for two calls:
            // - account/msisdn-fully-configured
            // - finance/subscription/payment
            // The root cause is that UserAddAction does not change the account (domain) in the store
            // fast enough to get it here
            const d = accountFromLocalStorage();
            const domainFromLocalStorage = d ? d.replace(/\"/g, '') : null;

            if (user.domain || domainFromLocalStorage) {
              req = req.clone({
                setHeaders: {
                  account: user.domain || domainFromLocalStorage
                }
              });
            }
          }
          return next.handle(req);
        });
    }
  }
}

export const AuthorizedHeaderInterceptor = {
  provide: HTTP_INTERCEPTORS,
  useClass: AuthorizedHeader,
  multi: true
};
